export default __webpack_public_path__ + "static/media/mc_3Suit.d60334a3.png";